import { FC, useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';

type Media = {
  url: string;
  alternativeText: string;
};

type SectionsFullWidthMediaProps = {
  data: {
    __typename?: string;
    enable_video_controls: boolean;
    full_widht_media: {
      desktop_media: Media[];
      mobile_media?: any;
      enable_mux_video?: boolean;
      mux_video?: {
        playback_id?: string;
      };
    };
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
  };
};

const ComponentSectionsFullWidthMedia: FC<SectionsFullWidthMediaProps> = ({ data }) => {
  // const { padding } = data;
  const sectionsFullWidthMedia = data;
  const muxPlaybackId = data.full_widht_media?.mux_video?.playback_id;
  const enableMuxVideo = data.full_widht_media?.enable_mux_video;
  const enable_video_controls = data?.enable_video_controls;

  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');
  const [showControlsClass, setShowControlsClass] = useState(false);

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);

  useEffect(() => {
    if (enable_video_controls) {
      setShowControlsClass(true); // ✅ Show class immediately
      const timer = setTimeout(() => {
        setShowControlsClass(false); // ✅ Remove class after 10s
      }, 10000); // 10,000ms = 10s
      return () => clearTimeout(timer);
    }
  }, [enable_video_controls]);
  return (
    <section
      className="col-div md:pb-[6rem] pb-[2.6rem] py-10 md:pt-24"
      id={sectionsFullWidthMedia?.__typename}
      style={{
        paddingTop: `${top}rem`,
        paddingBottom: `${bottom}rem`,
      }}
    >
      {enableMuxVideo && muxPlaybackId ? (
        <div className={showControlsClass ? 'show-controls-timer' : ''}>
          <MuxPlayer
            playbackId={muxPlaybackId}
            autoPlay
            muted
            loop
            playsInline
            className={enable_video_controls ? 'show-controls' : ''}
            streamType="on-demand"
            style={{ width: '100%' }}
            primaryColor="#e5e1d5"
            // secondaryColor="#1d3557"
            accentColor="#b6c380"
          />
        </div>
      ) : (
        <>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={sectionsFullWidthMedia?.full_widht_media?.desktop_media?.[0]?.url}
            alt={
              sectionsFullWidthMedia?.full_widht_media?.desktop_media[0]?.alternativeText ||
              'Desktop Image'
            }
            className="hidden md:block w-full h-auto"
          />

          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={
              sectionsFullWidthMedia?.full_widht_media?.mobile_media?.[0]?.url ||
              sectionsFullWidthMedia?.full_widht_media?.desktop_media?.[0]?.url
            }
            alt={
              sectionsFullWidthMedia?.full_widht_media?.mobile_media[0]?.alternativeText ||
              'Mobile Image'
            }
            className="block md:hidden w-full h-auto"
          />
        </>
      )}
    </section>
  );
};

export default ComponentSectionsFullWidthMedia;
